import script from "./TheHeaderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeaderCard.vue?vue&type=script&setup=true&lang=js"

import "./TheHeaderCard.vue?vue&type=style&index=0&id=4ad08073&scoped=true&lang=css"
script.__scopeId = "data-v-4ad08073"

export default script